import Dialog from '@/components/Dialog';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import styled from '@emotion/styled';
import { ReportOutlined as ErrorIconOutlined } from '@mui/icons-material';
import { ButtonBase, darken, lighten } from '@mui/material';
import { common } from '@mui/material/colors';

export const StyledErrorIcon = styled(ErrorIconOutlined)(
  ({ theme }) => ({
    padding: 4,
    width: 32,
    height: 32,
    color: theme.isDark ? darken(theme.palette.error.dark, 0.2) : undefined,
    backgroundColor: theme.isDark
      ? theme.palette.error.main
      : lighten(theme.palette.error.light, 0.7),
    boxSizing: 'border-box',
  }),
  addHighContrastStyles(({ theme }) => ({
    width: 34,
    color: common.black,
    background: 'none',
    borderRight: `2px solid ${theme.palette.divider}`,
  })),
);

export const ErrorMessage = styled(ButtonBase)(
  ({ theme }) => ({
    paddingLeft: 12,
    paddingRight: 12,
    font: 'inherit',
    fontSize: 13,
    fontWeight: 500,
    height: '100%',
    lineHeight: '32px',
    transition: theme.transitions.create(['color', 'background-color']),
    ':hover, :focus': {
      color: theme.isDark ? lighten(theme.palette.error.light, 0.3) : undefined,
      backgroundColor: theme.isDark
        ? darken(theme.palette.error.main, 0.2)
        : lighten(theme.palette.error.light, 0.7),
    },
  }),
  addHighContrastStyles(({ theme }) => ({
    color: theme.isDark ? common.black : theme.palette.text.primary,
    ':hover, :focus': {
      color: theme.isDark ? common.black : theme.palette.text.primary,
    },
  })),
);

export const StyledDialogTitle = styled(Dialog.Title)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  '.MuiSvgIcon-root': {
    marginRight: 12,
    width: 32,
    height: 32,
    color: theme.palette.error.main,
  },
}));
